import actionTypes from 'SRC/modules/redux/actionTypes'

export const setEquipmentVisibility = visibility => ({
  type: actionTypes.SET_EQUIPMENT_VISIBILITY,
  payload: visibility
})
